<script>
  export let text = ""
  export let state = false
  export let type = "button"
  export let iconClass = ""
  export let addClass = ""
</script>

<button on:click disabled={state} {type} class="ripple ripple:hover ripple:active flex select-none items-center justify-center rounded py-[7.52px] px-4 text-sm font-normal text-white outline-none hover:opacity-90 disabled:cursor-not-allowed {addClass}">
  <i class="fa-solid {iconClass}" />
  &nbsp;&nbsp;{text}
</button>
